var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFullStar = function SvgFullStar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 33 33",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "full-star"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#full-star)",
    stroke: "currentColor",
    d: "m17.092 25.455-.258-.156-.259.156-9.182 5.542 2.436-10.445.069-.294-.228-.198-8.113-7.028 10.682-.907.3-.025.118-.278 4.177-9.853 4.176 9.853.117.278.3.025 10.683.906-8.113 7.03-.228.197.069.294 2.436 10.445-9.182-5.542Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFullStar);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIGFyaWEtaGlkZGVuPSJ0cnVlIiB2aWV3Qm94PSIwIDAgMzMgMzMiPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJmdWxsLXN0YXIiPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9ImN1cnJlbnRDb2xvciIvPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmZmYiLz4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPC9kZWZzPgogICAgPHBhdGggZmlsbD0idXJsKCNmdWxsLXN0YXIpIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgZD0ibTE3LjA5MiAyNS40NTUtLjI1OC0uMTU2LS4yNTkuMTU2LTkuMTgyIDUuNTQyIDIuNDM2LTEwLjQ0NS4wNjktLjI5NC0uMjI4LS4xOTgtOC4xMTMtNy4wMjggMTAuNjgyLS45MDcuMy0uMDI1LjExOC0uMjc4IDQuMTc3LTkuODUzIDQuMTc2IDkuODUzLjExNy4yNzguMy4wMjUgMTAuNjgzLjkwNi04LjExMyA3LjAzLS4yMjguMTk3LjA2OS4yOTQgMi40MzYgMTAuNDQ1LTkuMTgyLTUuNTQyWiIvPgo8L3N2Zz4=";